export default __webpack_public_path__ + "static/media/calendar.72703d22.svg";